// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YearsList__list___1s1GY{display:flex;flex-wrap:wrap;grid-gap:24px;gap:24px}.YearsList__year___3w81t{padding:8px 20px;border-radius:24px;background-color:#fff4ee;cursor:pointer;transition-duration:.3s;transition-property:color,background-color;color:inherit;font-weight:400;font-size:20px;line-height:32px}.YearsList__year___3w81t:first-child{margin-left:0}.YearsList__year___3w81t:hover{color:#6b6651;background-color:#fffbf2}.YearsList__year___3w81t.YearsList__active___3sjLj{color:#fff;background-color:#2d50e6}.YearsList__year___3w81t.YearsList__active___3sjLj:hover{color:#fff;background-color:#829af2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"list": "YearsList__list___1s1GY",
	"year": "YearsList__year___3w81t",
	"active": "YearsList__active___3sjLj"
};
module.exports = ___CSS_LOADER_EXPORT___;
